import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container } from 'reactstrap';
import NewJobForm from './NewJobForm';
import Section from './Section'

const AddNewJob = () => {
  return (
    <React.Fragment>
      <Helmet>
        <title>Add New Job | Jobseekers Page </title>
      </Helmet>
      <Section />
      <section className="section">
        <Container>
          <NewJobForm/>
        </Container>
      </section>
    </React.Fragment>
  )
}

export default AddNewJob;